const BOARD = 'BOARD';
const LIST = 'LIST';
const CARD = 'CARD';
const TASK = 'TASK';

export default {
  BOARD,
  LIST,
  CARD,
  TASK,
};
